<template>
  <!--报名管理-->
  <div style="padding:40px">
    <!-- 搜索/导出 -->
    <el-form
      ref="form"
      :inline="true"
      :model="form"
      label-width="80px"
    >
      <el-form-item
        label="会议ID"
        v-show="false"
      >
        <el-input v-model="form.id"></el-input>
      </el-form-item>
      <el-form-item
        label="姓名："
        v-show="id"
      >
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="onSubmits"
          v-show="id"
        >搜索</el-button>
        <el-button
          type="primary"
          @click="daochu"
          v-show="!id"
        >导出</el-button>
        <el-button
          type="primary"
          @click="back"
          v-show="!id"
        >返回会议详情</el-button>
      </el-form-item>
    </el-form>
    <!-- 表格 -->
    <el-table
      :data="list"
      border
      style="width: 100%"
      v-loading="listLoading"
      id="out_table"
    >
      <el-table-column
        prop="order_no"
        label="订单号"
        width="230"
      ></el-table-column>
      <el-table-column
        prop="c_name"
        label="会议"
        width="170"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="tel"
        label="手机"
        width="120"
      ></el-table-column>
      <!-- <el-table-column prop="address" label="所属单位" width="300"></el-table-column> -->
      <el-table-column
        prop="ticket.name"
        label="门票类型"
        width="120"
      ></el-table-column>
      <el-table-column
        label="人数"
        width="120"
      >1</el-table-column>
      <el-table-column
        prop="ticket.price"
        label="订单金额"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="order.order_status"
        label="订单状态"
        width="120"
        :formatter="status"
      ></el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="120px"
      >
        <template slot-scope="scope">
          <el-button
            @click="handleClick(scope.row.order_no)"
            type="success"
            size="mini"
          >详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div style="width:100%;text-align: center">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        background
        :total="total"
        style="margin-top:20px;"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      /* 表格数据 */
      list: [],
      /* 搜索数据 */
      form: {
        ids: "",
        name: "",
      },
      /* 分页数据 */
      total: 0,
      pageSize: 8,
      listLoading: false,
      currentPage: 1,
      /*判断是否线下支付 */
      pay: false,
      id: true,
      o_id: "",
    };
  },
  created () {
    if (this.$route.query.id != undefined || this.$route.query.id != null)
    {
      this.form.ids = this.$route.query.id;
      this.o_id = this.$route.query.id;
      this.id = false;
      this.showTable(this.currentPage, this.pageSize);
    } else
    {
      this.showTable(this.currentPage, this.pageSize);
    }
  },
  mounted () {

  },
  methods: {
    /* 导出 */
    daochu () {
      window.location.href =
        "/ac1/conference/enroll/exportExcel?id=" + this.o_id +
        "&member_token=" +
        this.$cookies.get("member_token") +
        "&conferenceId=" + sessionStorage.getItem("conferenceId");;
    },
    /* back */
    back () {
      this.$router.push({
        path: "/admin/MeetingDetails",
        query: {
          editId: this.$route.query.id,
          cur: this.$route.query.cur,
        },
      });
      this.id = true;
    },
    /* 搜索事件 */
    onSubmits () {
      var _this = this
      _this.showTable(_this.currentPage, _this.pageSize)
    },
    /* 初始化表格 */
    showTable (currentPage, pageSize) {
      this.listLoading = true;
      let url = "/ac1/conference/enroll/memberList";
      let params = {
        page: currentPage,
        pagesize: pageSize,
        id: this.form.ids,
        name: this.form.name,
      };
      this.$get(url, params).then((res) => {
        console.log(res);
        this.listLoading = false;
        this.list = res.posts.data;
        this.total = res.posts.count;
      });
    },
    /* 订单状态判断 */
    status (row) {
      if (row.order.order_status == "waitting")
      {
        return "待支付";
      } else if (row.order.order_status == "finished")
      {
        return "已支付";
      } else if (row.order.order_status == "cancel")
      {
        return "已取消";
      } else if (row.order.order_status == "timeout")
      {
        return "超时关闭";
      } else if (row.order.order_status == "delete")
      {
        return "订单删除";
      } else if (row.order.order_status == "application")
      {
        return "申请退款";
      } else if (row.order.order_status == "refund")
      {
        return "退款成功";
      } else if (row.order.order_status == "reject")
      {
        return "退款驳回";
      } else
      {
        return "";
      }
    },
    /*查看详情==================== */
    handleClick (order_no) {
      this.$router.push({
        path: "/admin/Orderdetails",
        query: {
          id: order_no,
        },
      });
    },
    /*点击上一页,下一页 */
    handleSizeChange: function (size) {
      this.pageSize = size;
      console.log(this.pageSize); //每页下拉显示数据
      this.showTable(this.currentPage, this.pageSize);
    },
    /* 点击分页下标 */
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      console.log(this.currentPage); //点击第几页
      this.showTable(this.currentPage, this.pageSize);
    },
  },

};
</script>

<style scoped>
</style>
